<script>
export default {
    name: 'select-field',
    props: {
        autocomplete: {
            type: Boolean
        }
    }
};
</script>

<template>
    <v-select-custom v-if="!autocomplete" />
    <v-autocomplete-custom v-else />
</template>
